import React from 'react';

import Select from 'react-select';

import complyStatus from '@/data/complyStatus';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectComplyStatus: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={complyStatus.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={complyStatus}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectComplyStatus;
